import React from 'react';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import {green} from '@material-ui/core/colors';
import Fab from '@material-ui/core/Fab';
import RefreshIcon from '@material-ui/icons/Refresh';
import useInterval from "use-interval";
import moment from "moment";
import Tooltip from '@material-ui/core/Tooltip';
import {formatRemainingTime} from "../../js/DateUtils";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    fabProgress: {
        // color: green[500],
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
    },
    buttonProgress: {
        zIndex: 2,
    },
}));

const FabCountdownButton = ({seconds, refreshFunc, RefreshIconOverride, immediate, color = "secondary", className}) => {
    const classes = useStyles();

    const [lastRefresh, setLastRefresh] = React.useState();
    const [nextRefresh, setNextRefresh] = React.useState();
    const [timeRemainingFormatted, setTimeRemainingFormatted] = React.useState();
    const [refreshing, setRefreshing] = React.useState();
    const [pcnt, setPcnt] = React.useState();
    const ms = seconds * 1000;

    const timer = React.useRef();
    if (!RefreshIconOverride) RefreshIconOverride = RefreshIcon;

    if (!immediate)
        setNextRefresh(Date.parse(moment().add(seconds, 'seconds')));

    const refreshNow = async () => {
        try {
            setRefreshing(true);
            await refreshFunc();
            setLastRefresh(moment());
            setNextRefresh(Date.parse(moment().add(seconds, 'seconds')));
            setRefreshing(false);
        } finally {
            setRefreshing(false);
        }
    }

    useInterval(async () => {
        await refreshNow();
    }, ms, immediate);

    useInterval(async () => {
        if (!refreshing && nextRefresh) {
            const orig = nextRefresh - lastRefresh;
            const current = nextRefresh - new Date().getTime();
            setPcnt((orig - current) / orig * 100);
            if (!refreshing)
                setTimeRemainingFormatted(formatRemainingTime(new Date(nextRefresh)));
            else
                setTimeRemainingFormatted('Refreshing');
        }
    }, 1000, false);


    return (
        <div className={className}>
            <div className={classes.root}>
                <Tooltip title={'Next refresh in ' + timeRemainingFormatted} arrow>
                    <div className={classes.wrapper}>
                        <Fab
                            size="small"
                            color={color}
                            className={classes.buttonProgress}
                            onClick={refreshNow}
                            disabled={refreshing}
                        >
                            <RefreshIconOverride/>
                        </Fab>
                        {refreshing && <CircularProgress size={52} className={classes.fabProgress}/>}
                        {/*{pcnt}*/}
                        {!refreshing &&
                        <CircularProgress size={52} className={classes.fabProgress} value={pcnt} variant="static"/>}
                    </div>
                </Tooltip>
            </div>
        </div>
    );
}

export default FabCountdownButton;
